import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ContactInformation } from 'src/app/models/ContactInformation';

@Component({
    selector: 'app-contact-information-field',
    templateUrl: './contact-information-field.component.html',
    styleUrls: ['./contact-information-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ContactInformationFieldComponent {
    @Input() contactInformation: ContactInformation;
}
